import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';

export interface TravelEmptyStateProps {
  /**
   * 图标名称（MaterialIcons）
   */
  icon?: string;
  
  /**
   * 图标大小
   */
  iconSize?: number;
  
  /**
   * 图标颜色
   */
  iconColor?: string;
  
  /**
   * 主标题
   */
  title: string;
  
  /**
   * 副标题
   */
  subtitle?: string;
}

/**
 * Travel 模块空状态组件
 * 
 * 显示图标、标题和副标题，用于列表为空时的占位
 * 
 * @example
 * ```tsx
 * <TravelEmptyState
 *   icon="luggage"
 *   title="还没有旅行项目"
 *   subtitle="点击右上角按钮即可创建你的第一个旅行项目"
 * />
 * ```
 */
export const TravelEmptyState: React.FC<TravelEmptyStateProps> = ({
  icon = 'luggage',
  iconSize = 64,
  iconColor = '#ccc',
  title,
  subtitle,
}) => {
  return (
    <View style={styles.container}>
      <Icon name={icon} size={iconSize} color={iconColor} />
      <Text style={styles.title}>{title}</Text>
      {subtitle && <Text style={styles.subtitle}>{subtitle}</Text>}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 100,
    paddingHorizontal: 40,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#999',
    marginTop: 24,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: 14,
    color: '#ccc',
    marginTop: 8,
    textAlign: 'center',
    lineHeight: 20,
  },
});
